import React, { useState } from 'react';
import styled from 'styled-components';
import { Link, useLocation } from 'react-router-dom';
import logo from '../assets/logo.png';
import phoneIcon from '../assets/phone-icon.svg';
import gisLogo from '../assets/2gis-logo.svg';
import starIcon from '../assets/star-icon.svg';
import Popup from './Popup';
import ChinaConsultPopup from './ChinaConsultPopup';


const HeaderContainer = styled.header`
  background-color: #ededed;
  height: 84px;
  display: flex;
  align-items: center;
  position: relative;
  z-index: 10;
  
  @media (max-width: 479px) {
    height: 89px;
  }
`;

const HeaderContent = styled.div`
  max-width: 1200px;
  width: 100%;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;
  position: relative;
  
  @media (max-width: 479px) {
    display: flex;
    flex-wrap: wrap;
    padding: 0  25px;
    position: relative;
    height: 100%;
  }
`;

const Logo = styled.a`
  display: block;
  flex-shrink: 0;
  
  img {
    width: 200px;
    height: auto;
    
    @media (max-width: 479px) {
      width: 200px;
      position: absolute;
      left: 10px;
      top: 5px;
    }
  }
`;

const RightSection = styled.div`
  display: flex;
  align-items: center;
  gap: 30px;
  
  @media (max-width: 479px) {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    gap: 5px;
    margin-left: auto;
    width: auto;
  }
`;

const PhoneWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
  
  @media (max-width: 479px) {
    margin-top: 5px;
    
    a {
      font-size: 12px;
    }
    
    img {
      width: 16px;
      height: 16px;
    }
  }
`;

const PhoneIcon = styled.img`
  width: 25px;
  height: 25px;
  opacity: 0.55;
  
  @media (max-width: 479px) {
    width: 16px;
    height: 16px;
  }
`;

const PhoneLink = styled.a`
  font-size: 19px;
  color: #000;
  text-decoration: none;
  white-space: nowrap;
  
  @media (max-width: 479px) {
    font-size: 12px;
  }
`;

const RatingWrapper = styled.a`
  display: flex;
  align-items: center;
  gap: 10px;
  text-decoration: none;
  color: #000;
  
  @media (max-width: 479px) {
    gap: 5px;
  }
`;

const RatingBadge = styled.div`
  border: 1px solid rgba(0,0,0,0.1);
  border-radius: 10px;
  padding: 5px 10px;
  display: flex;
  align-items: center;
  gap: 5px;
  
  span {
    font-size: 18px;
    font-weight: 500;
    
    @media (max-width: 479px) {
      font-size: 13px;
    }
  }
  
  img {
    width: 12px;
    height: 12px;
    
    @media (max-width: 479px) {
      width: 8px;
      height: 8px;
    }
  }
`;

const GisLogo = styled.img`
  width: 96px;
  height: auto;
  
  @media (max-width: 479px) {
    width: 66px;
  }
`;

const Address = styled.div`
  font-size: 17px;
  line-height: 1;
  
  a {
    color: inherit;
    text-decoration: none;
  }
  
  @media (max-width: 479px) {
    font-size: 10px;
    max-width: 120px;
    text-align: right;
    
    a {
      font-size: 10px;
      line-height: 1.2;
    }
  }
`;

const Button = styled.button`
  width: 200px;
  height: 55px;
  background: linear-gradient(0deg, #FB8C22 0%, #FFBD7F 100%);
  border: none;
  border-radius: 17px;
  color: white;
  font-size: 14px;
  font-weight: 600;
  font-family: 'Geologica', Arial, sans-serif;
  cursor: pointer;
  transition: opacity 0.2s;
  flex-shrink: 0;
  
  &:hover {
    opacity: 0.9;
  }
  
  @media (max-width: 960px) {
    width: 180px;
    height: 50px;
    font-size: 13px;
  }
  
  @media (max-width: 479px) {
    display: none;
  }
`;

const Header = () => {
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [isChinaConsultPopupOpen, setIsChinaConsultPopupOpen] = useState(false);
  const location = useLocation();
  
  // Определяем, находимся ли мы на странице Китая
  const isChinaPage = location.pathname === '/china';

  const handleButtonClick = () => {
    if (isChinaPage) {
      setIsChinaConsultPopupOpen(true);
    } else {
      setIsPopupOpen(true);
    }
  };
  return (
    <>
      <HeaderContainer>
        <HeaderContent>
          <Link to="/">
          <Logo >
            <img src={logo} alt="Максимум тур" />
          </Logo>
          </Link>
          <RightSection>
            <PhoneWrapper>
              <PhoneIcon src={phoneIcon} alt="phone" />
              <PhoneLink href="tel:+79964269652">+7 (996) 426-96-52</PhoneLink>
            </PhoneWrapper>
            
            <RatingWrapper href="https://go.2gis.com/E5XHe">
              <RatingBadge>
                <span>4.9</span>
                <img src={starIcon} alt="rating" />
              </RatingBadge>
              <GisLogo src={gisLogo} alt="2GIS" />
            </RatingWrapper>
            
            <Address>
              <a href="https://go.2gis.com/E5XHe">
                Владивосток Алеутская улица, 45а
              </a>
            </Address>
          </RightSection>
          
          <Button onClick={handleButtonClick}>
            Заявка на тур
          </Button>
        </HeaderContent>
      </HeaderContainer>
      
      <Popup isOpen={isPopupOpen} onClose={() => setIsPopupOpen(false)} />
      <ChinaConsultPopup isOpen={isChinaConsultPopupOpen} onClose={() => setIsChinaConsultPopupOpen(false)} />
    </>
  );
};

export default Header;